import React, { useEffect, useState } from "react";
import { styled } from "@stitches/react";
import { Typography, Accordion, AccordionSummary, AccordionDetails, Button, CircularProgress } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Container } from "semantic-ui-react";
import { UserService } from "../../services/userService";

export const UserProfilePage: React.FC = () => {
  const [user, setUser] = useState<{
    givenName: string;
    familyName: string;
    companyName: string;
    email: string;
    secondaryEmail?: string;
    messagePreference: string;
    phoneNumber: string
    street: string;
    city: string;
    state: string;
    zip: string;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await UserService.getUserProfile();
        setUser(data);
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <StyledCircularProgressContainer>
        <CircularProgress />
      </StyledCircularProgressContainer>
    );
  }
  if (!user) return <Typography>No user data found.</Typography>;

  const editProfile = () => {
    window.location.href = "/profile/edit";
  };

  const viewPaymentHistory = () => {
    // Requirements preference was to keep this under Profile instead of adding another top-level nav item.
    window.location.href = "/profile/payment-history";
  };

  return (
    <Container style={{ minHeight: "75vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div style={{ marginTop: "3rem", width: "100%", maxWidth: 600 }}>
        <Typography variant="h3">User Profile</Typography>
        <Accordion expanded={isOpen} onChange={() => setIsOpen(!isOpen)} defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>Profile Details</AccordionSummary>
          <AccordionDetails style={{ flexDirection: "column", gap: "0.5rem" }}>
            <Typography><strong>Given Name:</strong> {user.givenName}</Typography>
            <Typography><strong>Family Name:</strong> {user.familyName}</Typography>
            <Typography><strong>Company:</strong> {user.companyName}</Typography>
            <Typography><strong>Primary Email:</strong> {user.email}</Typography>
            <Typography>
              <strong>Secondary Email:</strong>{" "}
              {user.secondaryEmail || "Not set"}
            </Typography>
            <Typography><strong>Phone Number:</strong> {user.phoneNumber}</Typography>
            <Typography><strong>Message Preference:</strong> {user.messagePreference === "both" ? "Email and SMS" : user.messagePreference.toUpperCase()}</Typography>
            <Typography><strong>Street:</strong> {user.street}</Typography>
            <Typography><strong>City:</strong> {user.city}</Typography>
            <Typography><strong>State:</strong> {user.state}</Typography>
            <Typography><strong>Zip:</strong> {user.zip}</Typography>
          </AccordionDetails>
        </Accordion>
        <Button type="submit" variant="outlined" color="primary" style={{ marginTop: "0.3rem" }} onClick={editProfile}>
          Edit Profile
        </Button>
        <Button
          variant="outlined"
          color="primary"
          style={{ marginTop: "0.3rem", marginLeft: "0.5rem" }}
          onClick={viewPaymentHistory}
        >
          View Payment History
        </Button>
      </div>
    </Container>
  );
};

const StyledCircularProgressContainer = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "center",
});